import { LinkService } from '@chr/online-shared-microsite-core';

export const RedirectToPageNotFound = (): null => {
  LinkService.getLinks().then(() => {
    window.location.assign(LinkService.PAGE_NOT_FOUND);
  });
  return null;
}
